import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Combobox 컨트롤러 - Design System v3
// Tom Select 기반의 검색 가능한 드롭다운 (새 항목 생성 가능)
export default class extends Controller {
  static targets = ["input"]
  static values = {
    options: { type: Array, default: [] },
    placeholder: { type: String, default: "검색하세요" },
    createLabel: { type: String, default: '"{input}" 추가' },
    noResultsText: { type: String, default: "검색 결과가 없습니다" },
    multi: { type: Boolean, default: false },
    create: { type: Boolean, default: true },
    maxItems: { type: Number, default: null }
  }

  connect() {
    this.initTomSelect()
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }

  initTomSelect() {
    const config = {
      plugins: this.multiValue ? ["remove_button"] : [],
      options: this.optionsValue,
      items: this.getInitialItems(),
      valueField: "value",
      labelField: "label",
      searchField: ["label", "value"],
      placeholder: this.placeholderValue,
      maxItems: this.multiValue ? (this.maxItemsValue || null) : 1,
      create: this.createValue ? this.handleCreate.bind(this) : false,
      render: {
        no_results: () => {
          return `<div class="no-results">${this.noResultsTextValue}</div>`
        },
        option_create: (data, escape) => {
          const label = this.createLabelValue.replace("{input}", escape(data.input))
          return `<div class="create">${label}</div>`
        }
      },
      onInitialize: () => {
        this.applyDesignSystemStyles()
      },
      onChange: (value) => {
        this.dispatch("change", { detail: { value } })
      }
    }

    this.tomSelect = new TomSelect(this.inputTarget, config)
  }

  handleCreate(input) {
    return {
      value: input,
      label: input
    }
  }

  getInitialItems() {
    const value = this.inputTarget.value
    if (!value) return []

    if (this.multiValue) {
      return value.split(",").map(v => v.trim()).filter(v => v)
    }
    return [value]
  }

  applyDesignSystemStyles() {
    // Design System v3 스타일 적용
    const wrapper = this.inputTarget.closest(".ts-wrapper")
    if (!wrapper) return

    // Control wrapper 스타일
    const control = wrapper.querySelector(".ts-control")
    if (control) {
      control.classList.add(
        "!min-h-[40px]",
        "!rounded-sm",
        "!border-[var(--border)]",
        "!bg-[var(--background)]",
        "!px-3",
        "!text-sm"
      )
    }

    // Dropdown 스타일
    const dropdown = wrapper.querySelector(".ts-dropdown")
    if (dropdown) {
      dropdown.classList.add(
        "!rounded-md",
        "!border-[var(--border)]",
        "!shadow-[0_4px_12px_rgba(0,0,0,0.12)]"
      )
    }
  }

  // 외부에서 값 설정
  setValue(value) {
    if (this.tomSelect) {
      this.tomSelect.setValue(value, true)
    }
  }

  // 외부에서 옵션 추가
  addOption(option) {
    if (this.tomSelect) {
      this.tomSelect.addOption(option)
    }
  }

  // 초기화
  clear() {
    if (this.tomSelect) {
      this.tomSelect.clear()
    }
  }
}
